var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "faq-section" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _vm.faqs.length > 0
                    ? _c("FaqList", { attrs: { faqs: _vm.faqs } })
                    : _c("h4", { staticClass: "text-center" }, [
                        _vm._v("There are currently no FAQs for this product."),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }